export const profilesPicNames = [
  {
    src: 'https://qa.sprouts.ai/profile-pics/karan-profilepic.jpeg',
    name: 'Karan Chaudhry',
    designation: 'Cofounder and CEO of Sprouts.ai',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/kapil-profilepic.jpeg',
    name: 'Kapil Chaudhry',
    designation: 'Co-Founder & CTO @ Sprouts.ai',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/avi-profilepic.jpg',
    name: 'Avinash Nagla',
    designation: 'Cofounder and COO at Sprouts.ai',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/ava-chang-profilepic.jpeg',
    name: 'Ava Chang',
    designation: 'VC & Growth Investor at Pruven Capital',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/victoria-cheng-profilepic.webp',
    name: 'Victoria Cheng',
    designation: 'Partner at PruVen Capital',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/shekhar-kirani-profile-pic.jpg',
    name: 'Shekhar Kirani',
    designation: 'Partner at Accel',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/bill-brown-profilepic.jpeg',
    name: 'Bill Brown',
    designation: 'Senior Vice President of Sales & Partnerships',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/jim-hirschauer-profilepic.jpeg',
    name: 'Jim Hirschauer',
    designation: 'VP of Marketing',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/john-nardo-profilepic.jpeg',
    name: 'John Nardo',
    designation: 'Strategic Accounts and Partners',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/anupam-profile-pic.jpeg',
    name: 'Anupam',
    designation: 'SVP',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/vishnu-profile-pic.jpeg',
    name: 'Vishnu',
    designation: 'Founder',
  },
  {
    src: 'https://qa.sprouts.ai/profile-pics/vignesh-profile-pic.jpeg',
    name: 'Vignesh',
    designation: 'Growth Leader',
  },
];
